
export const IBR = "30"; // finger/card enrolment
export const RB = "29"; // finger/card enrolment
export const IDEMIA_MASIGMA = "18"; // finger enrolment
export const IDEMIA_MASIGMA_WAVE = "31"; // hand enrolment
export const IDEMIA_VISION_PASS = "34";	// face enrolment
export const IDEMIA_VISION_PASS_SP = "48";	// face enrolment
export const SUPREMA_FACESTATION2 = "32"; // face enrolment
export const SUPREMA_FACELITE = "33"; // face enrolment
export const SUPREMA_FUSION = "39"; // face enrolment
export const DS_HIKVISION = "41"; // face enrolment
export const CONTROLID_iDFace = "42"; // face enrolment
export const CONTROLID_iDFaceMax = "47"; // face enrolment
export const HID_AMICO = "49"; // face enrolment
export const CONTROLID_iDAccess = "43"; // finger/card enrolment
export const EABR_UNIT_TYPE_ID = "240" 